export const BASE_URL = "https://no-opinion.jike.cafe"
// export const APP_KEY = "Ybz2Z7TNpb9KzGCo"
// export const TOKEN = "e0fa8774e4af4ec8990e2d7a938bf415"